import React, { Component } from 'react';
import '../css/dataTables.css';
import '../css/responsive.css';
import $ from 'jquery';
import DataTablesCreate from "./DataTablesCreate";
import { ApiClient, ApiResponse } from '../libs/apiClient';
import { DISPATCH_ID, SERVICE_RESPONSE } from '../libs/utils/Const';
import { connect } from 'react-redux';

let headers = [
    { title: 'Código' },
    { title: 'Descripción' },
    { title: 'Stock General' },
];
let apiClient = ApiClient.getInstance();
class ItemsListModal extends Component {
    status
    constructor(props) {
        super(props);

        this.state = {
            status: true,
            ItemsArray: [],
            saveData: true
        };

    }

    componentWillReceiveProps() {
        const { ItemsArray } = this.state;
        if (ItemsArray.length) {
            this.setState({ // tog
                checkboxArray: (new Map()),
                status: false
            });
        } else {
            this.setState({ // tog
                status: true
            });
        }

    }

    closeItems = async () => {
        const { cleanData } = this.props;
        const state = this;
        this.setState({
            ItemsArray: [],
            saveData: true
        });
        cleanData();
        state.setState({
            checkboxArray: (new Map())
        })


        $('#itemsListModal').modal('hide');
    }

    closeAction = () => {
        const { cleanData } = this.props;
        const state = this;
        cleanData();
        state.setState({
            checkboxArray: (new Map()),

        });
    };


    selectItems = array => {

        let bandera = true;

        for (let [id, value] of array.entries()) {
            if (value) {
                bandera = false;
            }
        }

        // if(bandera){
        //     document.getElementById('guardar').disabled = false;
        // }else{
        //     document.getElementById('guardar').disabled = true;
        // }
        this.setState({ // tog
            checkboxArray: array,
            status: bandera
        });

    };

    selectItemsToArray = () => {
        const { data, selectItems } = this.props;
        const { checkboxArray, ItemsArray } = this.state;

        let items = ItemsArray;
        // if(ItemsArray != []){
        //     items.push(ItemsArray);

        // }

        for (let [id, value] of checkboxArray.entries()) {
            if (value) {
                items.push(data[id]);
            }
        }
        selectItems(items);
        this.setState({
            status: true,
            ItemsArray: [],
            saveData: true
        });
        this.closeItems()

    };

    DobleClick = () => {
    };
    searchItemMod = async (search = '', PageNumber, itemsPage = null) => {
        const { enableSpinner, refreshItems, newOrderModel, mainView, typeSearch } = this.props;
        enableSpinner(true)
        let getItemResponse = await apiClient.getListItems(search, mainView, PageNumber, Number(newOrderModel?.ItemTypeSearch ?? 4));
        enableSpinner(false)

        if (getItemResponse.status === SERVICE_RESPONSE.SUCCESS) {
            refreshItems(getItemResponse.data.results, getItemResponse.data.totalPage);
        }
    };
    searchItems = async (item, PageNumber, itemsPage) => {
        await this.searchItemMod(item, PageNumber, itemsPage);
    };
    addItemBack = async () => {
        const { data, selectItems } = this.props;
        const { checkboxArray, ItemsArray } = this.state;
        let items = ItemsArray;

        for (let [id, value] of checkboxArray.entries()) {
            if (value) {
                items.push(data[id]);
            }
        }
        this.setState({
            status: true,
            ItemsArray: items
        });


    };
    handleSwitchChange = () => {
        const { saveData } = this.state
        let save = !saveData;
        this.setState({
            saveData: save
        });
    }

    render() {
        const { data, totalPage, newOrderModel, DisabledItems, notificationReducer: { showAlert }, typeSearch } = this.props
        const { status, saveData } = this.state;
        const searchitem = typeSearch === 'head' ? newOrderModel.TreeCode : typeSearch === 'lines' ? newOrderModel.searchItemMaterial : newOrderModel ? newOrderModel?.searchItem ?? '' : '';
        if (data.length === 0) {
            return <div className="modal fade bd-example-modal-lg bgtransparent" role="dialog" id="itemsListModal"></div>;
        }

        //className="w-100 table-scroll tab-pane fade show active "  aria-labelledby="nav-home-tab-Contenido" style={{marginBottom: 0, minheight: 450, maxHeight: 570}}
        return (
            <div>
                <div className="modal fade bd-example-modal-lg modal-open scroll" data-backdrop="false" role="dialog" id="itemsListModal" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-open" role="document">
                        <div className="modal-content">

                            <div className="modal-header text-white" style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                                <h4 className="modal-title" id="modal-basic-title ">Artículos</h4>
                                <button type="button" className="close" onClick={this.closeItems} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body" >
                                <div className="contanier">
                                    <div className="row justify-content-around">
                                        <div className="col-12">
                                            <div className='table-responsive'>
                                                <table className="table response" style={{ marginBottom: 0 }}>
                                                    <tbody>
                                                        <DataTablesCreate
                                                            showAlert={showAlert}
                                                            data={data}
                                                            totalPage={totalPage}
                                                            headers={headers} view={"itemsListModal"} action={this.selectItems} search={this.searchItems} searchInTable={searchitem} addItemBack={this.addItemBack} saveData={saveData} DisabledItems={DisabledItems} />
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer articulosres">
                                {!DisabledItems ? <label><input type="checkbox" id="cbox1" value="first_checkbox" onChange={this.handleSwitchChange} /> Mantener artículos seleccionados</label> : ''}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <button type="button" className="btn botonCerrar text-white" onClick={this.closeItems}>Cerrar</button>
                                <button type="button" id="guardar" className="btn botonCorrect" disabled={status} onClick={this.selectItemsToArray} onDoubleClick={this.DobleClick}>Agregar</button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* {this.closeAction()} */}
            </div>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ItemsListModal);